import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as PATTERNS from '../../shared/regex-patterns';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { IPolicies } from 'src/app/shared/models/policies.interface';
import { ScriptService } from 'src/app/services/script.service';
import { BillingService } from 'src/app/services/billing.service';
import { PolicyService } from 'src/app/services/policy.service';
import { GuestLinkService } from 'src/app/services/guest-link.service';
import { UserPermission } from 'src/app/shared/models/user-permission';
import { IEmail } from 'src/app/shared/models/email.interface';
import { Permissions } from '../../shared/models/permissions';
import { IS4UPSService } from 'src/app/services/is4ups.service';
import { ALL_SPECIAL_CHARACTERS } from '../../shared/regex-patterns';
import { CustomToastComponent } from '../claims-custom/tupss/tupss-edit/components/custom-toast/custom-toast.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IDocumentDisplay } from 'src/app/shared/models/claim.interface';
import { environment as ENV } from '../../../environments/environment';
import { LoginService } from 'src/app/services/login.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'upsc-internal-user',
  templateUrl: './internal-user.component.html',
  styleUrls: ['./internal-user.component.scss']
})
export class InternalUserComponent implements OnInit {
  //Error scenarios
  systemError: boolean;
  initialPageLoad: boolean = false;
  notFound = false;
  systemError1: boolean;
  notFound1 = false;
  didNotMatch = false;
  codExpired = false;
  showResult = false;
  notFound_Code = false;
  systemError_Code: boolean;
  submitting_Code: boolean = false;
  isCollapsed: boolean = false;
  isCollapsed2: boolean = false;
  isCampaingnCollapsed: boolean = true;
  showIS4UPSResult: boolean = false;
  loading: boolean = false;
  submitError: boolean = false;
  successMsg: boolean = false;
  traditionalCargo: boolean = false;
  invalidError: boolean = false;
  //Data
  policyForm: UntypedFormGroup;
  policyForm1: UntypedFormGroup;
  emailForm: UntypedFormGroup;
  IS4UPSForm: UntypedFormGroup;
  policy: IPolicies;
  getVerificationCodeData;
  policies;
  policyType: string;
  maxDate: any;
  isMobile: any;

  emailId: IEmail;
  policyNumber: IPolicies;
  //emailPolicy: IPolicies;
  ccpSelfservice = {
    ccp_selfService_Check: false,
    unique_Partner_Name: ""
  };

  //Page logic
  submitting: boolean = false;
  submitting1: boolean = false;
  validButNoData: boolean = false;
  showSMBButton: boolean = false;
  showVerificationCode: boolean = false;
  hideInternalUserFlow: boolean = false;
  isCustomerSupport: boolean = false;
  public userPermission: UserPermission = new UserPermission();
  public permissions: Permissions[] = [];
  is4upsIndicator: boolean = false;


  //File Upload
  fileToUpload: File = null;
  errorList = [];
  removeDocumentError: boolean = false;

  //buckets
  campaignFiles = [];
  campaignFileDownloadLink = ENV.links.IS4UPSCampaignTemplate;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private titleService: Title,
    private translateService: TranslateService,
    private scriptService: ScriptService,
    private billingService: BillingService,
    private policyService: PolicyService,
    private guestLinkService: GuestLinkService,
    private is4upsService: IS4UPSService,
    private loginService: LoginService,
    private snackBar: MatSnackBar,
    private datePipe: DatePipe,
  ) {
    this.initialPageLoad = true;
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.translateService.instant('app.Settitle.ups_capital_internal'));
    this.validateTokens();

    this.IS4UPSForm = this.fb.group({
      policyNumber: ['', [Validators.required, Validators.pattern(PATTERNS.POLICY_PATTERN)]],
      currentRate: ['', [Validators.required]],
      currentMinLimit: ['', [Validators.required]],
      currentMaxLimit: ['', [Validators.required]],
      newRate: ['', [Validators.required]],
      newMinLimit: ['', [Validators.required]],
      newMaxLimit: ['', [Validators.required]],
      emailAddress: ['', [Validators.required, Validators.pattern(PATTERNS.EMAIL_PATTERN)]],
      createdDateTime: ['', [Validators.required]],
    });

    this.policyForm = this.fb.group({
      policy: ['', [Validators.required, Validators.pattern(PATTERNS.POLICY_PATTERN)]],
    });

    this.policyForm1 = this.fb.group({
      policy1: ['', [Validators.required, Validators.pattern(PATTERNS.POLICY_PATTERN)]],
    });

    this.emailForm = this.fb.group({
      emailId: ['', [Validators.required, Validators.pattern(PATTERNS.EMAIL_PATTERN)]],
      //emailPolicy: ['', [Validators.required, Validators.pattern(PATTERNS.POLICY_PATTERN)]],
    });
  }

  validateTokens() {
    const idToken = localStorage.getItem('id_token');
    this.userService.validateIDToken(idToken).subscribe(
      data => {
        if (data?.message == 'Valid' && data?.rlsUserDetails?.permissions && data?.rlsUserDetails?.permissions?.length > 0) {
          sessionStorage.setItem('permissions', JSON.stringify(data.rlsUserDetails.permissions));
          sessionStorage.setItem('userid', JSON.stringify(data.rlsUserDetails.id));
          this.is4upsIndicator = data.rlsUserDetails.is4upsIndicator;

          this.userService.setUserPermissions(data.rlsUserDetails.permissions);

          let userDetails = {
            active: true,
            approved: true,
            contactName: data.rlsUserDetails.name,
            emailAddress: data.rlsUserDetails.email,
            firstName: data.rlsUserDetails.given_name,
            lastName: data.rlsUserDetails.family_name,
            permissions: data.rlsUserDetails.permissions,
            policyHoldersName: '',
            userId: data.rlsUserDetails.id,
            userRoleID: data.rlsUserDetails.app_Role == 'Adjuster' ? "2" : "1",
            app_role_id: data.rlsUserDetails.app_Role_Id,
            internalUser: true,
            app_role_name: data.rlsUserDetails.app_Role,
            userPreference: {
              userPreferenceID: '',
              preferenceName: '',
              productCategory: '',
              carrier: '',
              address: {
                addressID: '',
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                city: '',
                state: '',
                zip: '',
                country: ''
              }
            },
            smbIndicator: data.rlsUserDetails.smbIndicator
          }
          this.userService.setUserInfo(userDetails);
          sessionStorage.setItem('userDetails', JSON.stringify(userDetails));

          this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
          if (this.permissions?.length > 0) {
            this.isCustomerSupport = this.permissions.find(x => x.permissionName === 'VerificationCode') ? true : false;

            if (this.isCustomerSupport && this.permissions?.length == 1) {
              this.showVerificationCode = true;
              this.hideInternalUserFlow = true;
            } else if (this.isCustomerSupport && this.permissions?.length > 1) {
              this.showVerificationCode = true;
              this.hideInternalUserFlow = false;
              this.isCollapsed = true;
            }
          }

          this.checkSMB();
          this.initialPageLoad = false;
          if (data.rlsUserDetails.app_Role == 'Adjuster') {
            this.router.navigate(['adjusterDashboard']);
          }
        } else {
          this.initialPageLoad = false;
          this.router.navigate(['unauthorized']);
        }
      }, error => {
        this.initialPageLoad = false;
        this.systemError = true;
        this.router.navigate(['unauthorized']);
      }
    );
  }

  startOver(event: any) {

  }

  continue() {
    this.notFound = false;
    this.systemError = false;
    this.invalidError = false;

    if (!this.policyForm.valid) {
      this.policyForm.markAllAsTouched();
      return;
    }
    
    if (!/^[a-zA-Z0-9][a-zA-Z0-9\-.]{4,}[a-zA-Z0-9]$/.test(this.policyForm.controls.policy.value)) {
      this.invalidError = true;
      return;
    }

    this.submitting = true;
    this.userService.getPolicySearch(this.policyForm.controls.policy.value).subscribe(
      policydata => {
        this.submitting = false;
        if (policydata?.data && policydata?.message?.toLowerCase() == 'succeeded') {
          this.policy = policydata.data;
          sessionStorage.setItem('policyDetails', JSON.stringify(policydata.data));
          /* if (JSON.parse(sessionStorage.getItem('userDetails'))?.app_role_id === 1) {
            this.checkPolicyExist(this.policy.policyNumber);
          } */
          this.userService.updateUserInfo({
            policyNumber: policydata.data.policyNumber,
            policyHoldersName: policydata.data.insured
          });
          this.scriptService.pendoInit();

          // add DWgetSummary call here before finishing the login process and navigating user in to ONL.
          // regardless of if this call succeeds or fails, we will still navigate to the dashboard after
          let dwRequest = {
            productSourceSystem: "gw",
            sourceSystemIdentifierName: "PolicyNumber",
            sourceSystemIdentifier: policydata?.data?.policyNumber,
            country: "US",
            roleType: "string",
            productType: "string"
          }
          this.billingService.DWgetSummary(dwRequest).subscribe(
            data => {
              try {
                if (data?.data?.wallet) {
                  sessionStorage.setItem('dwDetails', JSON.stringify(data.data.wallet))
                }
                this.checkForChildPolicies();
              } catch (e) {
                this.checkForChildPolicies();
              }
            }, error => {
              this.checkForChildPolicies();
            }
          );
        } else {
          //Error was still 200, but not "succeeded", most likely it got a "nodata"
          this.notFound = true;
        }
      },
      err => {
        this.submitting = false;
        if (err?.error?.message.toLowerCase() == 'nodata') {
          this.notFound = true;
        }
        else {
          this.systemError = true;
        }
      }
    )
  }

  getIS4UPSDetails() {
    this.notFound1 = false;
    this.systemError = false;
    this.successMsg = false;
    this.showIS4UPSResult = false;
    if (!this.policyForm1.valid) {
      this.policyForm1.markAllAsTouched();
      return;
    }
    this.submitting1 = true;
    this.policyService.retrieveIS4UPSInfo(this.policyForm1.controls.policy1.value).subscribe(
      data => {
        if (data?.message?.toLowerCase() == 'no data found' && data?.code == 200) {
          this.userService.getPolicySearch(this.policyForm1.controls.policy1.value).subscribe(
            policydata => {
              if (policydata?.data && policydata?.message?.toLowerCase() == 'succeeded') {
                this.policy = policydata.data;
                sessionStorage.setItem('policyDetails', JSON.stringify(policydata.data));
                this.policies = this.loginService.getPolicyDetails();
                this.policyType = this.policyService.determinePolicyType(this.policies);
                if (this.policyType.toLowerCase() == 'traditional_cargo') { //If it is traditional Cargo we should skip them to add the new record in DB.
                  this.traditionalCargo = true;
                  this.showIS4UPSResult = false;
                  this.submitting1 = false;
                  this.validButNoData = false;
                } else {
                  this.submitting1 = false; //In this case we Need to ask for new record insert
                  this.validButNoData = true;
                  this.notFound1 = false;
                  this.traditionalCargo = false;
                }
              } else {
                //Error was still 200, but not "succeeded", most likely it got a "nodata"
                this.notFound1 = true;
                this.submitting1 = false;
              }
            },
            err => {
              this.submitting = false;
              if (err?.error?.message.toLowerCase() == 'nodata') {
                this.notFound1 = true;
              }
              else {
                this.systemError = true;
              }
            }
          )
        } else {
          this.loadIS4UPSQuoteDetails(data?.data);
          this.showIS4UPSResult = true;
          this.submitting1 = false;
        }
      }, error => {
        this.systemError = true;
        this.submitting1 = false;
      }
    );
  }

  addData() {
    this.showIS4UPSResult = true;
    this.IS4UPSForm.controls.policyNumber.setValue(this.policyForm1.controls.policy1.value);
    this.validButNoData = false;
    this.clearData();
    this.IS4UPSForm.markAsUntouched();
  }

  submitIS4UPSDetails() {
    if (!this.IS4UPSForm.valid) {
      this.IS4UPSForm.markAllAsTouched();
      return;
    }
    this.loading = true;
    this.submitError = false;
    let request = {
      policyNumber: this.policyForm1.controls.policy1.value,
      currentRate: this.IS4UPSForm.controls.currentRate.value,
      currentMinLimit: this.IS4UPSForm.controls.currentMinLimit.value,
      currentMaxLimit: this.IS4UPSForm.controls.currentMaxLimit.value,
      newRate: this.IS4UPSForm.controls.newRate.value,
      newMinLimit: this.IS4UPSForm.controls.newMinLimit.value,
      newMaxLimit: this.IS4UPSForm.controls.newMaxLimit.value,
      emailAddress: this.IS4UPSForm.controls.emailAddress.value,
      createdDateTime: this.IS4UPSForm.controls.createdDateTime.value,
    }
    this.policyService.updateIS4UPSInfo(request).subscribe(
      data => {
        this.loading = false;
        if (data?.data?.message == 'Upserted successfully') {
          this.successMsg = true;
          setTimeout(() => {
            this.snackBar.openFromComponent(CustomToastComponent, {
              data: { message: 'Details Updated successfully!' },
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
          });
          //this.clearData();
        } else {
          this.submitError = true;
        }
      }, error => {
        this.loading = false;
        this.submitError = true;
      }
    );
  }

  clearData() {
    this.IS4UPSForm.controls.emailAddress.setValue('');
    this.IS4UPSForm.controls.currentRate.setValue('');
    this.IS4UPSForm.controls.currentMinLimit.setValue('');
    this.IS4UPSForm.controls.currentMaxLimit.setValue('');
    this.IS4UPSForm.controls.newRate.setValue('');
    this.IS4UPSForm.controls.newMinLimit.setValue('');
    this.IS4UPSForm.controls.newMaxLimit.setValue('');
    this.IS4UPSForm.controls.createdDateTime.setValue(new Date());
  }

  checkIS4UPSQuoteDetails() {
    let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
    sessionStorage.removeItem('is4upsQuoteDetails');
    // Flow 1: User does not have TC coverage. We're trying to convert some IS4U policyholders to TC right now, see if their policy exists in the control table.
    if (policyDetails?.hasTCCoverage == true) {
      this.policyService.retrieveIS4UPSInfo(policyDetails?.policyNumber).subscribe(
        data => {
          this.loadIS4UPSQuoteDetails(data?.data);
          // Only store value to sessionStorage if they have a pre-approved quote.
          if (data?.data && data?.data?.newRate) {
            sessionStorage.setItem('is4upsQuoteDetails', JSON.stringify(data?.data));
            this.router.navigate(['dashboard']);
          } else if (this.userService.isUSPSUser()) {
            this.router.navigate(['billing']);
          }
          else {
            this.router.navigate(['dashboard']);
          }
        }, error => {
          this.router.navigate(['dashboard']);
        }
      );
    } else if (this.userService.isUSPSUser()) {
      this.router.navigate(['billing']);
    }
    else { // Flow #2: They already have TC coverage, just continue logging in.
      this.router.navigate(['dashboard']);
    }
  }

  /* checkPolicyExist(policynum) {
    var guestLinkRequest = {
      PolicyNumber: policynum
    }

    this.policyService.checkPolicyExist(guestLinkRequest).subscribe(response => {
      if (response && response.data && response.message === 'Found' && response.data.portalType.toLowerCase() === 'ssp') {
        this.ccpSelfservice.ccp_selfService_Check = true;
        this.ccpSelfservice.unique_Partner_Name = response.data.partnerName;
        sessionStorage.setItem("ccpUniquePartnerName", JSON.stringify(this.ccpSelfservice));
        this.guestLinkService.ccpSSPChecked(this.ccpSelfservice.unique_Partner_Name);
      }
    }, error => {
      console.log(error);
    });
  } */

  loadIS4UPSQuoteDetails(info) {
    this.IS4UPSForm.controls.policyNumber.setValue(info.policyNumber);
    this.IS4UPSForm.controls.currentRate.setValue(info.currentRate);
    this.IS4UPSForm.controls.currentMinLimit.setValue(info.currentMinLimit);
    this.IS4UPSForm.controls.currentMaxLimit.setValue(info.currentMaxLimit);
    this.IS4UPSForm.controls.newRate.setValue(info.newRate);
    this.IS4UPSForm.controls.newMinLimit.setValue(info.newMinLimit);
    this.IS4UPSForm.controls.newMaxLimit.setValue(info.newMaxLimit);
    this.IS4UPSForm.controls.emailAddress.setValue(info.emailAddress);
    const onlyDate = this.datePipe.transform(info.createdDateTime, 'MM-dd-yyyy');
    this.IS4UPSForm.controls.createdDateTime.setValue(new Date(onlyDate));
  }

  checkForChildPolicies() {
    if (this.userService.isParentPolicy()) {
      this.policyService.getListOfChildPolicies({ parentPolicyNumber: this.userService.getUserInfo().policyNumber }).subscribe(
        data => {
          if (data && data.data && data.data.childPolicies) {
            sessionStorage.setItem('childPolicies', JSON.stringify(data.data.childPolicies));
            this.checkIS4UPSQuoteDetails();
          } else {
            this.checkIS4UPSQuoteDetails();
          }
        }, error => {
          this.checkIS4UPSQuoteDetails();
        }
      );
    } else {
      this.checkIS4UPSQuoteDetails();
    }
  }

  checkSMB() {
    let userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    if (userDetails.smbIndicator && !userDetails.app_role_id) {
      // console.log('should auto navigate to SMB');
      this.showSMBButton = false;
      this.navigateToSMB();
    } else if (userDetails.smbIndicator && userDetails.app_role_id) {
      // console.log('should show button option to navigate to SMB');
      this.showSMBButton = true;
    } else {
      this.showSMBButton = false;
      // console.log("not smb");
    }
  }

  navigateToSMB() {
    this.router.navigate(['/prospect']);
    window.scrollTo(0, 0);
  }

  getVerificationCode() {
    this.systemError = false;
    this.notFound_Code = false;
    this.didNotMatch = false;
    this.codExpired = false;
    this.systemError_Code = false;
    if (!this.emailForm.valid) {
      this.emailForm.markAllAsTouched();
      return;
    }
    let request = {
      em: this.emailForm.controls.emailId.value, // em stands for email
      //pno: this.emailForm.controls.emailPolicy.value // pno stands for policy number
    }
    this.submitting_Code = true;
    this.userService.getVerificationCode(request).subscribe(
      data => {
        this.submitting_Code = false;
        if (data?.data && data?.message?.toLowerCase() == 'success' && data?.data?.verificationCode != null) {
          this.getVerificationCodeData = data?.data;
          this.showResult = true;
          this.isCollapsed2 = false;
          this.showVerificationCode = false;
        } else if (data?.message?.toLowerCase() == 'not found' && data?.data?.verificationCode == null && data?.code == 200) {
          this.showResult = false;
          this.isCollapsed = false;
          this.notFound_Code = true;
        } else if (data?.data == null && data?.message?.toLowerCase() == 'not match' && data?.code == 200) {
          this.showResult = false;
          this.isCollapsed = false;
          this.didNotMatch = true;
        }
        else if (data?.message?.toLowerCase() == 'expired' && data?.code == 200) {
          this.showResult = false;
          this.isCollapsed = false;
          this.codExpired = true;
        }
      },
      err => {
        this.submitting_Code = false;
        this.systemError_Code = true;
        this.isCollapsed = false;
      }
    )
  }
  getNewCode() {
    this.showResult = false;
    this.showVerificationCode = true;
    this.emailForm.controls.emailId.reset();
    //this.emailForm.controls.emailPolicy.reset();
    this.didNotMatch = false;
    this.notFound_Code = false;
    this.codExpired = false;
    this.isCollapsed = false;
  }

  //Input: list of documents
  //Output: list of documents, and whether or not they should be uploaded, and reasoning for that.
  //Checks for things such as filename, filesize, max # of documents per bucket
  preliminaryDocumentChecks(listOfDocs, bucket): any[] {
    let checkedDocumentList = [];

    for (let i = 0; i < listOfDocs.length; i++) {
      const file = listOfDocs.item(i);
      let object = { file: file, shouldBeUploaded: true, reasonToNotUpload: '' };
      if (file.name.length > 80) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'The file name exceeds the maximum limit of 70 characters';
      }

      /*if (file.size >= 10000000) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'File size exceeds 7MB';
      }*/

      if (bucket == 'IS4UPS-Campaign-Files' && this.campaignFiles.find(x => x.file.name == file.name)) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'Duplicate files are not allowed';
      }
      checkedDocumentList.push(object)
    }
    return checkedDocumentList;
  }


  uploadDocument(files: FileList, bucket: string, event?): void {

    this.clearDocumentErrors();
    let checkedDocumentsList = this.preliminaryDocumentChecks(files, bucket);

    if (event?.target?.value) {
      event.target.value = null;  //This is required in the scenario the user tries to upload (A), it fails, and then they try to upload (A) again.
    }

    //Now try to upload documents 
    if (checkedDocumentsList && checkedDocumentsList.length > 0) {
      for (let i = 0; i < checkedDocumentsList.length; i++) {
        if (checkedDocumentsList[i].shouldBeUploaded) {
          this.uploadFile(checkedDocumentsList[i].file, bucket);
        } else {
          this.errorList.push({ filename: checkedDocumentsList[i].file.name, error: checkedDocumentsList[i].reasonToNotUpload });
        }
      }
    }
  }

  //When user tries to upload a document with special characters, sned it to GW with spaces replacing the special characters
  formatFileName(file) {
    let extension = file.name.substring(file.name.lastIndexOf('.'));
    let fileNameWithoutExtension = file.name.substring(0, file.name.lastIndexOf('.'));

    try {
      fileNameWithoutExtension = fileNameWithoutExtension.replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, ' ');
      fileNameWithoutExtension = fileNameWithoutExtension.replace(ALL_SPECIAL_CHARACTERS, ' ');
      fileNameWithoutExtension = fileNameWithoutExtension.trim();
    } catch (e) { }

    return `${fileNameWithoutExtension}${extension}`;
  }

  uploadFile(file, bucket) {
    let formData: FormData = new FormData();
    formData.append('file', file, this.formatFileName(file));
    this.is4upsService.uploadDocument(formData).subscribe(
      response => {
        console.log(response.message);
        if (response.message === 'Success') {
          // Add the file to the appropriate bucket
          if (bucket === "IS4UPS-Campaign-Files") {
            this.campaignFiles.push({ file: file, publicID: 1 });
          }
          setTimeout(() => {
            this.snackBar.openFromComponent(CustomToastComponent, {
              data: { message: 'Your document has been successfully uploaded.' },
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
          });
        } else if (response.code === 500 && response.exception === 'There are not enough fields in the Structured type.  Structured types must have at least one field.') {
          this.errorList.push({ filename: file.name, error: 'Empty File is not allowed, please add atleast one record' });
        } else {
          this.errorList.push({ filename: file.name, error: 'System error. Please try again' });
        }
      }, error => {
        this.errorList.push({ filename: file.name, error: 'System error. Please try again' });
      }
    );
  }

  removeDocument(file: IDocumentDisplay) {
    this.removeDocumentError = false;
    this.campaignFiles.splice(this.campaignFiles.indexOf(file), 1);
  }


  clearDocumentErrors() {
    this.errorList = [];
  }

  downloadTemplate() {
    window.location.href = this.campaignFileDownloadLink;
  }



}
